import {combineReducers} from '@modifi/redux'
import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import {FileInfoView} from '@modifi/onboarding-api-clients'
import collectionReducer from './collection'
import updateReducer from './update'

export default combineReducers({
  collection: collectionReducer,
  update: updateReducer,
})

export type CompanyDocumentsState = {
  collection: KeyWindowState<FileInfoView>
  update: any
}
